<template>
	<!-- <div>
		<el-tabs type="border-card">
		  <el-tab-pane label="销售收入">  	
		  </el-tab-pane>
		  <el-tab-pane label="用户拉新">
			  	<el-card shadow="hover" class='general_total'>
		        <span>本月活跃医生</span>
		        <span class="active_mount">20000人</span><br>
		        <span>本月注册医生</span>
		        <span class="active_mount">20000人</span>
	          	<el-button type="text" class="button">
	          		<i class="iconfont icon-refresh_01 refresh_icon"></i>
	          	</el-button>
		    </el-card>
		    图表
		    <div id="newChart"></div>
		  </el-tab-pane>
		  <el-tab-pane label="用户活跃">
		  	<el-card shadow="hover" class='general_total'>
		        <span>本月注册医生</span>
		        <span class="active_mount">20000人</span>
	          	<el-button type="text" class="button">
	          		<i class="iconfont icon-refresh_01 refresh_icon"></i>
	          	</el-button>
		    </el-card>
		    图表
		    <div id="saleChart"></div>
		  </el-tab-pane>
		</el-tabs>
	</div> -->
	<div class="bg">
		<img :src="require('assets/img/welcome.png')">
		<!-- <router-link to='/demo'>to demo</router-link> -->
	</div>
</template>

<script scoped>
	export default {
		name: 'general',
		data() {
            return {
                
            }
		},
		mounted() {
/*			this.drawSaleChart()
			this.drawNewChart()
*/		},
		methods: {
			drawSaleChart(){
		        // 基于准备好的dom，初始化echarts实例
		        let saleChart = this.$echarts.init(document.getElementById('saleChart'))
		        // 绘制图表
		        saleChart.setOption({
		            title: {
		            	text: '医生活跃报表',
		            	subtext: '6月'
		            },
		            legend: {
        				data:['活跃医生']
    				},
				    tooltip: {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross'
				        },
				        formatter: "6月{b}日<br/>活跃医生:{c}"
				    },
		            xAxis: {
		                data: ['1','2','3','4','5','6','7',
		                '8','9','10' ,'11','12','13','14',
		                '15','16','17','18','19','20','21',
		                '22','23','24','25','26','27','28',
		                '29','30','31'],
                        axisLabel: {
				            formatter: '{value} 日'
				        },
		            },
		            yAxis: {},
		            series: [{
		                name: '活跃医生',
		                type: 'line',
        				smooth: true,
		                data: [5, 20, 36, 10, 10, 20,5, 20, 36, 10, 10, 20]
		            }]
	        	});
		    },

			drawNewChart(){
		        // 基于准备好的dom，初始化echarts实例
		        let saleChart = this.$echarts.init(document.getElementById('newChart'))
		        // 绘制图表
		        saleChart.setOption({
		            title: {
		            	text: '医生拉新报表',
		            	subtext: '6月'
		            },
		            legend: {
        				data:['注册医生','认证医生']
    				},
				    tooltip: {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross'
				        },
				        // formatter: "6月{b}日<br/>活跃医生:{c}"
				    },
		            xAxis: {
		                data: ['1','2','3','4','5','6','7',
		                '8','9','10' ,'11','12','13','14',
		                '15','16','17','18','19','20','21',
		                '22','23','24','25','26','27','28',
		                '29','30','31'],
                        axisLabel: {
				            formatter: '{value} 日'
				        },
		            },
		            yAxis: {},
		            series: [{
		                name: '注册医生',
		                type: 'line',
        				smooth: true,
		                data: [5, 20, 36, 10, 10, 20,5, 20, 36, 10, 10, 20]
		            },{
		                name: '认证医生',
		                type: 'line',
        				smooth: true,
		                data: [10, 20, 36, 10, 10, 0,5, 20, 36, 10, 10, 20]
		            }]
	        	});
		    }
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	.bg{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(to bottom, #e7f2fd, #f4f8ff);
		img{
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			margin: auto;
		}
	}
	.general_total{
		width: fit-content;
		background: #ff9999;
		color: #fff;
		&:hover{
			background: #fd9191;
		}
	}
	.active_mount{
		margin: 0 30px 0 10px;
	}
	.refresh_icon{
		color: #fff;
		font-size: 20px;
	}
	#saleChart,
	#newChart{
		width: 1000px;
		height: 500px;
		margin-top: 20px;
	}
</style>

<style type="text/less" lang="less">
	.el-card__body{
		padding:5px 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/general/index.vue